import { firebaseConfig as config } from './config'

// Add additional config options here:
export const firebaseConfig = {
  ...config,
  debug: true
}

